export default {
    props: {
        value: {
            required: true
        },
        saveCallback: {
            type: Function,
            required: true
        },
        showEditIcon: {
            type: Boolean,
            default: true
        },
        highlightOnHover: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    created() {
        this.internalValue = this.value
    },
    watch: {
        value: {
            handler(n,o) {
                if (n !== o) {
                    this.value = n
                }
            },
            deep: true
        }
    },
    mounted() {
        this.$refs.base.$on('save', this.save)
        this.$refs.base.$on('cancel', this.reset)
    },
    data() {
        return  {
            internalValue: {},
            isSaving: false,
            canSave: true,
        }
    },
    computed: {
        bindings() {
            return {
                label: this.label,
                isSaving: this.isSaving,
                canSave: this.canSave,
                showEditIcon: this.showEditIcon,
                highlightOnHover: this.highlightOnHover,
                size: this.size,
            }
        }
    },
    methods:{
        reset() {
            this.isSaving = false
            this.canSave = true
            this.internalValue = this.value
            this.$refs.base.$refs.dropdown.close()
        },
        save() {
            this.isSaving = true
            this.saveCallback(this.internalValue).then(() => {
                this.$emit('saved')
                this.reset()
            }).catch(e => {
                handleApiError(e)
                this.isSaving = false
            })
        },
        cancel() {
            this.reset()
            this.$emit('cancelled')
        }
    }
}